

export const getAspectRatioHeight = (width: number, aspect: string) => Math.ceil(width / eval(aspect));